<!-- Empty State -->
<div class="empty-state" *ngIf="!leaseDetailService.getTermDataSafely()">
  <i class="pi pi-info-circle"></i>
  <h3>No hay un término de cotización aprobado</h3>
  <p>Por favor selecciona el término de la cotización aprobado por el cliente para visualizar este apartado.</p>
</div>

<!-- Main Container -->
<div class="billing-container" *ngIf="leaseDetailService.getTermDataSafely()">
  <!-- Header Principal -->
  <div class="billing-header">
    <div class="header-content">
      <div class="header-left">
        <i class="fa-solid fa-receipt"></i>
        <div class="header-text">
          <h1>Resumen de Cobranza</h1>
          <p class="header-subtitle">Información detallada del estado financiero del arrendamiento</p>
        </div>
      </div>
      <div class="header-right">
        <button
          pButton
          type="button"
          icon="fa-regular fa-file-pdf"
          class="pdf-button p-button-outlined"
          (click)="downloadAccountStatement()"
          pTooltip="Descargar Estado de Cuenta"
          tooltipPosition="top"
        ></button>
        <p-tag [value]="data?.status" [severity]="data?.status === 'Activo' ? 'success' : 'info'" icon="pi pi-info-circle"> </p-tag>
      </div>
    </div>
  </div>

  <!-- Cards Grid -->
  <div class="cards-grid">
    <!-- Tarjeta 1: Información General del Arrendamiento -->
    <div class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-info-circle text-blue-600"></i>
        <h3>Información General</h3>
      </div>
      <div class="card-content">
        <div class="compact-grid">
          <div class="compact-item">
            <span class="label">Inicio de Arrendamiento</span>
            <span class="value">{{ table.startDate ? (table.startDate | date: 'dd/MM/yyyy' : 'UTC') : '-' }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Tipo de Arrendamiento</span>
            <span class="value">{{ data?.quotation?.leaseType }}</span>
          </div>
          <div class="compact-item">
            <span class="label">TIR</span>
            <span class="value">{{ leaseDetailService.getTermDataSafely()?.irr | number: '1.2-2' }} %</span>
          </div>
          <div class="compact-item">
            <span class="label">Tasa de Interés</span>
            <span class="value">{{ data?.quotation?.interestRate | number: '1.2-2' }} %</span>
          </div>
          <div class="compact-item">
            <span class="label">Plazo en Meses</span>
            <span class="value">{{ leaseDetailService.getTermDataSafely()?.term }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Rentas Anticipadas</span>
            <span class="value">{{ leaseDetailService.getTermDataSafely()?.advancedRents?.number }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjeta 2: Montos del Financiamiento -->
    <div class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-dollar-sign text-purple-600"></i>
        <h3>Montos del Financiamiento</h3>
      </div>
      <div class="card-content">
        <div class="compact-grid">
          <div class="compact-item">
            <span class="label">Valor Pagaré</span>
            <span class="value success">{{ data?.quotation?.amountToFinance | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Pago Inicial</span>
            <span class="value">{{ leaseDetailService.getTermDataSafely()?.downPayment?.total | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Comisión por Apertura</span>
            <span class="value">{{ data?.quotation?.openingCommission?.percentage * 100 | number: '1.2-2' }} %</span>
          </div>
          <div class="compact-item">
            <span class="label">Monto Comisión</span>
            <span class="value">{{ data?.quotation?.openingCommission?.total | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Gastos de Ratificación</span>
            <span class="value">{{ data?.quotation?.ratificationExpenses | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Valor Residual</span>
            <span class="value">{{ leaseDetailService.getTermDataSafely()?.residuary?.total | currency }}</span>
          </div>
          <div class="compact-item full-width">
            <span class="label">Pago Total Arrendamiento</span>
            <span class="value success">{{ leaseDetailService.getTermDataSafely()?.totalLeasePayment | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjeta 3: Estado de la Cobranza -->
    <div class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-chart-line text-green-600"></i>
        <h3>Estado de la Cobranza</h3>
      </div>
      <div class="card-content">
        <div class="financial-compact">
          <div class="financial-row">
            <span class="label">Rentas por Cobrar</span>
            <span class="value">{{ data?.rents?.rentsToCollect }}</span>
          </div>
          <div class="financial-row">
            <span class="label">Monto de Rentas por Cobrar</span>
            <span class="value">{{ data?.rents?.rentsToCollectAmount | currency }}</span>
          </div>
          <div class="financial-divider"></div>
          <div class="financial-row">
            <span class="label">Rentas Cobradas</span>
            <span class="value">{{ table.collected.count }}</span>
          </div>
          <div class="financial-row">
            <span class="label">Monto de Rentas Cobradas</span>
            <span class="value">{{ table.collected.amount | currency }}</span>
          </div>
          <!-- Las anticipadas se cobran en el pago inicial, no por letra: van aparte para que no parezcan cobradas en $0 -->
          <ng-container *ngIf="table.anticipated.count > 0">
            <div class="financial-row">
              <span class="label">Rentas Anticipadas (pago inicial)</span>
              <span class="value">{{ table.anticipated.count }}</span>
            </div>
            <div class="financial-row">
              <span class="label">Monto de Rentas Anticipadas</span>
              <span class="value">{{ table.anticipated.amount | currency }}</span>
            </div>
          </ng-container>
          <div class="financial-divider"></div>
          <div class="financial-row total">
            <span class="label">Valor de Cartera</span>
            <span class="value">{{ data?.wallet?.walletValue | currency }}</span>
          </div>
          <div class="financial-row">
            <span class="label">Valor sin Accesorios</span>
            <span class="value">{{ data?.wallet?.walletValueWithoutAccessories | currency }}</span>
          </div>
          <div class="financial-divider"></div>
          <!-- Lentes (F36): la combinación se arma en el cliente sumando componentes -->
          <div class="financial-row lens-row" *ngIf="components as c">
            <span class="label">Incluir</span>
            <span class="value lens-boxes">
              <span class="field-checkbox"
                ><p-checkbox [(ngModel)]="lens.accessories" [binary]="true" inputId="lensAcc"></p-checkbox
                ><label for="lensAcc">Accesorios {{ c.accessories | currency }}</label></span
              >
              <span class="field-checkbox"
                ><p-checkbox [(ngModel)]="lens.residual" [binary]="true" inputId="lensRes"></p-checkbox
                ><label for="lensRes">Residual {{ c.residual | currency }}</label></span
              >
              <span class="field-checkbox"
                ><p-checkbox [(ngModel)]="lens.mora" [binary]="true" inputId="lensMora"></p-checkbox
                ><label for="lensMora">Mora {{ c.mora | currency }}</label></span
              >
            </span>
          </div>
          <div class="financial-row total" *ngIf="components">
            <span class="label">Cartera con la lente</span>
            <span class="value">{{ carteraFiltrada | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Tarjeta 4: Desglose de la Renta -->
    <div class="info-card">
      <div class="card-header">
        <i class="fa-solid fa-file-invoice-dollar text-orange-600"></i>
        <h3>Desglose de la Renta</h3>
      </div>
      <div class="card-content">
        <div class="section-header-mini">
          <i class="pi pi-money-bill"></i>
          <span>Renta Mensual</span>
          <span class="rent-source" *ngIf="table.rent?.period !== null && table.rent?.period !== undefined">
            Letra {{ table.rent?.period
            }}<ng-container *ngIf="table.rent?.date"> · {{ table.rent?.date | date: 'dd/MM/yyyy' : 'UTC' }}</ng-container>
          </span>
          <span class="rent-source" *ngIf="table.rent?.source === 'quotation'">Según cotización</span>
        </div>
        <div class="compact-grid">
          <div class="compact-item">
            <span class="label">Subtotal</span>
            <span class="value">{{ table.rent?.amount | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Accesorios</span>
            <span class="value">{{ table.rent?.accessories | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">IVA</span>
            <span class="value">{{ table.rent?.iva | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Total Renta</span>
            <span class="value success">{{ table.rent?.total | currency }}</span>
          </div>
        </div>

        <div class="section-header-mini" style="margin-top: 1.5rem">
          <i class="pi pi-shopping-cart"></i>
          <span>Accesorios Mensuales Financiados</span>
        </div>
        <div class="compact-grid">
          <div class="compact-item full-width">
            <span class="label">Conceptos</span>
            <span class="value">{{
              leaseDetailService.getTermDataSafely()?.accessoriesDetail?.financed?.total?.concepts || 'Sin accesorios'
            }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Capital</span>
            <span class="value">{{ table.rent?.accessoriesDetail?.capital | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Interés</span>
            <span class="value">{{ table.rent?.accessoriesDetail?.interest | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">IVA</span>
            <span class="value">{{ table.rent?.accessoriesDetail?.iva | currency }}</span>
          </div>
          <div class="compact-item">
            <span class="label">Total Accesorios</span>
            <span class="value success">{{ table.rent?.accessoriesDetail?.total | currency }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
